import { Star, Quote } from "lucide-react";
import { useLang } from "../i18n";
import { Reveal, Eyebrow } from "./common";

export default function Testimonials() {
    const { t } = useLang();

    return (
        <section id="depoimentos" className="relative py-24 md:py-32 bg-deep">
            <div className="max-w-7xl mx-auto px-5 md:px-10">
                <Reveal className="mb-14 max-w-2xl">
                    <Eyebrow>{t.testimonials.eyebrow}</Eyebrow>
                    <h2 className="mt-4 font-display font-extrabold tracking-tight text-3xl sm:text-4xl lg:text-5xl leading-[1.05]">
                        {t.testimonials.title}
                    </h2>
                    <p className="mt-4 text-slate-400">{t.testimonials.sub}</p>
                </Reveal>

                <div className="grid md:grid-cols-3 gap-5">
                    {t.testimonials.items.map((item, i) => (
                        <Reveal key={item.name} delay={i * 0.12} className="h-full">
                            <figure
                                data-testid={`testimonial-card-${i + 1}`}
                                className="relative h-full flex flex-col rounded-2xl border border-white/10 bg-surface/60 p-8 hover:border-volt/40 transition-colors"
                            >
                                <Quote className="absolute top-7 right-7 w-8 h-8 text-volt/15" />
                                <div className="flex gap-1 mb-6">
                                    {Array.from({ length: 5 }).map((_, s) => (
                                        <Star
                                            key={s}
                                            className="w-4 h-4 text-volt fill-volt"
                                        />
                                    ))}
                                </div>
                                <blockquote className="text-sm md:text-[15px] text-slate-300 leading-relaxed flex-1">
                                    “{item.text}”
                                </blockquote>
                                <figcaption className="mt-7 pt-5 border-t border-white/10">
                                    <p className="font-display font-bold">{item.name}</p>
                                    <p className="font-mono text-[10px] uppercase tracking-[0.18em] text-slate-500 mt-1">
                                        {item.role}
                                    </p>
                                </figcaption>
                            </figure>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
}
